// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://multiverse-tools-backend.onrender.com';

export default API_BASE_URL;
